import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
    import { log } from '@/utils/logger'
    import Modal from '@/components/Modal.vue'
    import { getLegalDocumentHtml } from '@/services/api'
    import LoadingIndicator from '@/components/LoadingIndicator.vue'
    import ShadowDom from '@/components/ShadowDom.vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentRenderModal',
  props: {
    docType: null,
    title: null,
    show: { type: Boolean },
    ssn: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
            (e: 'close'): void
        }), expose: any, slots: any, attrs: any }) {

const props = __props as {
            docType: string
            title: string
            show: boolean
            ssn?: string
        }

    

    

    const onModalCloseClick = () => {
        emit('close')
    }

    const shouldShowModal = computed(() => props.show)
    const loading = ref(false)
    const renderedDocumentHtml = ref<string | null>(null)

    onMounted(() => {
        // download html regardless of whether we have ssn
        downloadHtml()
    })

    const downloadHtml = async () => {
        try {
            loading.value = true
            const pdfLegalDocumentResponse = await getLegalDocumentHtml(props.docType, props.ssn)
            renderedDocumentHtml.value = pdfLegalDocumentResponse?.data
        } catch (e) {
            log.error('Could not download legal document %{docType}', { docType: props.docType, error: e })
            return false
        }
        loading.value = false
        return true
    }

    watch(shouldShowModal, (newVal) => {
        log.info('showRef: %{newVal}', { newVal })
        if (newVal) {
            downloadHtml()
        }
    })

return { __sfc: true,props, emit, onModalCloseClick, shouldShowModal, loading, renderedDocumentHtml, downloadHtml, Modal, LoadingIndicator, ShadowDom }
}

})